import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ArrowUpRight } from 'lucide-react';
import { Link } from 'react-router-dom';
const projects = [{
  id: 29,
  title: 'Twin Canopy Villa',
  location: 'Tagaytay',
  type: 'Residential',
  image: 'https://cdn.magicpatterns.com/uploads/sddMVLMp2gz2GcnThCJrr9/Screenshot_2026-07-03_at_1.33.32_PM.png'
}, {
  id: 30,
  title: 'Twilight Ridge House',
  location: 'Antipolo',
  type: 'Residential',
  image: 'https://cdn.magicpatterns.com/uploads/rzpfebRP8rVp9M2UNwASwu/Screenshot_2026-07-03_at_1.33.37_PM.png'
}, {
  id: 2,
  title: 'Serenity Villas',
  location: 'Tagaytay',
  type: 'Residential',
  image: 'https://cdn.magicpatterns.com/uploads/t2rPPQtzR2J1sXWUZfKxKX/pasted-image.webp'
}, {
  id: 3,
  title: 'BGC Cultural Center',
  location: 'Bonifacio Global City',
  type: 'Residential',
  image: 'https://cdn.magicpatterns.com/uploads/w9gt9aomyyaErnAeC56qp8/pasted-image.webp'
}, {
  id: 5,
  title: 'Ortigas Tech Hub',
  location: 'Pasig City',
  type: 'Residential',
  image: 'https://cdn.magicpatterns.com/uploads/jtcpb4Uy29N8H7kiC91SQd/pasted-image.webp'
}, {
  id: 6,
  title: 'Palawan Eco Resort',
  location: 'El Nido',
  type: 'Residential',
  image: 'https://cdn.magicpatterns.com/uploads/uukxdryEXD6h47HShW3FZP/pasted-image.webp'
}, {
  id: 8,
  title: 'Batangas Retreat',
  location: 'Batangas',
  type: 'Residential',
  image: 'https://cdn.magicpatterns.com/uploads/pwFiYCWA5yYdTaNmKWSoHE/pasted-image.webp'
}, {
  id: 9,
  title: 'Cauayan Mixed-Use',
  location: 'Cauayan City',
  type: 'Commercial',
  image: 'https://cdn.magicpatterns.com/uploads/ur3SwZBsEzM8Zx2neEfW4y/Cauayan-Perspective_2.jpg'
}, {
  id: 10,
  title: 'Bridgelink Terminal',
  location: 'Sorsogon',
  type: 'Commercial',
  image: 'https://cdn.magicpatterns.com/uploads/1nYAkiSvysEtagepXDyKqC/BRIDGELINK_PERSPECTIVE_Photo_-_4.jpg'
}, {
  id: 12,
  title: 'SM City Cauayan',
  location: 'Cauayan City',
  type: 'Commercial',
  image: 'https://cdn.magicpatterns.com/uploads/iMQhVypBnV3m1cejrjx7sg/Gemini_Generated_Image_275ftn275ftn275f.png'
}, {
  id: 13,
  title: 'Atrium Residence',
  location: 'Metro Manila',
  type: 'Residential',
  image: 'https://cdn.magicpatterns.com/uploads/pZxVqLDkdE7nmhg6Y54dMH/Screenshot_2026-07-03_at_12.59.22_PM.png'
}, {
  id: 14,
  title: 'Ridge House',
  location: 'Antipolo',
  type: 'Residential',
  image: 'https://cdn.magicpatterns.com/uploads/iboe9qug1YKCzGeLkKjEHi/pasted-image.jpg'
}, {
  id: 15,
  title: 'Minimalist Kitchen Residence',
  location: 'Quezon City',
  type: 'Residential',
  image: 'https://cdn.magicpatterns.com/uploads/7CjYsjim6V81v35zG8Bdtw/pasted-image.jpg'
}, {
  id: 16,
  title: 'Garden View Living',
  location: 'Alabang',
  type: 'Residential',
  image: 'https://cdn.magicpatterns.com/uploads/uVX2zsViiXEf6iMU4SFanV/pasted-image.jpg'
}, {
  id: 17,
  title: 'Twilight Villa',
  location: 'Tagaytay',
  type: 'Residential',
  image: 'https://cdn.magicpatterns.com/uploads/mtYT796SkoF5aUCPDCwRJd/pasted-image.jpg'
}, {
  id: 18,
  title: 'SM Center Dagupan',
  location: 'Dagupan City',
  type: 'Commercial',
  image: 'https://cdn.magicpatterns.com/uploads/fNbam1S4WS6dBHycoFFsUU/pasted-image.jpg'
}, {
  id: 19,
  title: 'SM City Iloilo',
  location: 'Iloilo City',
  type: 'Commercial',
  image: 'https://cdn.magicpatterns.com/uploads/1iqvfSym9fVnXuk41pRVSs/pasted-image.jpg'
}, {
  id: 20,
  title: 'SM City Trece Martires',
  location: 'Trece Martires',
  type: 'Commercial',
  image: 'https://cdn.magicpatterns.com/uploads/2X6TN1BTXKjEqB3Vky19E4/Screenshot_2026-07-03_at_1.09.24_PM.png'
}, {
  id: 21,
  title: 'Commercial Warehouse Facility',
  location: 'Luzon',
  type: 'Commercial',
  image: 'https://cdn.magicpatterns.com/uploads/6kfLp4botm3rVZ2b1TDpec/Screenshot_2026-07-03_at_1.10.40_PM.png'
}, {
  id: 22,
  title: 'Timber Screen Residence',
  location: 'Metro Manila',
  type: 'Residential',
  image: 'https://cdn.magicpatterns.com/uploads/kyrrypzn8V86bzUn4xxvS5/Screenshot_2026-07-03_at_12.13.14_PM.png'
}, {
  id: 23,
  title: 'Twin Pavilion Home',
  location: 'Tagaytay',
  type: 'Residential',
  image: 'https://cdn.magicpatterns.com/uploads/fMu9hFuX1MYqhuUTNL7Dza/Screenshot_2026-07-03_at_12.13.23_PM.png'
}, {
  id: 25,
  title: 'Stone Facade Residence',
  location: 'Quezon City',
  type: 'Residential',
  image: 'https://cdn.magicpatterns.com/uploads/dfbVr7D7y7YRLiJRTWz7RC/_11A7295-2-Edit.jpg'
}, {
  id: 26,
  title: 'Vertical Fin House',
  location: 'Alabang',
  type: 'Residential',
  image: 'https://cdn.magicpatterns.com/uploads/cdT1HEFYK351kY5ZK13sXE/Screenshot_2026-07-03_at_12.12.07_PM.png'
}, {
  id: 27,
  title: 'Canopy Residence',
  location: 'Rizal',
  type: 'Residential',
  image: 'https://cdn.magicpatterns.com/uploads/jLGGbbxpDwDZwNeFWSsyUS/Screenshot_2026-07-03_at_12.12.17_PM.png'
}, {
  id: 28,
  title: 'Curved Louvre House',
  location: 'Batangas',
  type: 'Residential',
  image: 'https://cdn.magicpatterns.com/uploads/t3sTLoSBSvco6C8UmmJHV6/Screenshot_2026-07-03_at_12.12.37_PM.png'
}];
export function ProjectsSection() {
  const [filter, setFilter] = useState<'Residential' | 'Commercial'>('Residential');
  const filteredProjects = projects.filter(p => p.type === filter);
  return <section id="projects" className="py-24 md:py-32 bg-bg-warm" data-id="element-169">
      <div className="max-w-7xl mx-auto px-4 md:px-6" data-id="element-170">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-16 space-y-6 md:space-y-0" data-id="element-171">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-172">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-light text-primary leading-tight tracking-tight" data-id="element-173">
              Featured <span className="text-accent" data-id="element-174">Projects</span>
            </h2>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="flex flex-col items-start md:items-end space-y-6" data-id="element-175">
            <div className="inline-flex items-center gap-8" data-id="element-176">
              {(['Residential', 'Commercial'] as const).map(cat => <button key={cat} onClick={() => setFilter(cat)} className={`relative uppercase tracking-widest text-sm font-light transition-colors duration-300 ${filter === cat ? 'text-primary' : 'text-text-muted hover:text-primary'}`} data-id="element-177">
                  {cat}
                  {filter === cat && <motion.span layoutId="projects-filter-indicator" className="absolute -bottom-1.5 left-0 right-0 h-px bg-accent" transition={{
                type: 'spring',
                stiffness: 400,
                damping: 32
              }} data-id="element-178" />}
                </button>)}
            </div>

            <Link to="/projects" className="text-text-muted uppercase tracking-widest text-sm font-light hover:text-accent transition-colors flex items-center space-x-2 border-b border-neutral-300 hover:border-accent pb-1" data-id="element-179">
              <span data-id="element-180">View All Projects</span>
              <ArrowUpRight size={16} data-id="element-181" />
            </Link>
          </motion.div>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-2 gap-4 md:gap-6 items-start" data-id="element-182">
          <div className="space-y-4 md:space-y-6" data-id="element-183">
            <AnimatePresence mode="popLayout" data-id="element-184">
              {filteredProjects.filter((_, i) => i % 2 === 0).map((project, index) => <ProjectCard key={project.id} project={project} index={index} data-id="element-185" />)}
            </AnimatePresence>
          </div>
          <div className="space-y-4 md:space-y-6 md:mt-24" data-id="element-186">
            <AnimatePresence mode="popLayout" data-id="element-187">
              {filteredProjects.filter((_, i) => i % 2 !== 0).map((project, index) => <ProjectCard key={project.id} project={project} index={index} data-id="element-188" />)}
            </AnimatePresence>
          </div>
        </div>
      </div>
    </section>;
}
function ProjectCard({
  project,
  index
}: {
  project: any;
  index: number;
}) {
  return <motion.div layout initial={{
    opacity: 0,
    y: 50,
    rotateX: 8
  }} animate={{
    opacity: 1,
    y: 0,
    rotateX: 0
  }} exit={{
    opacity: 0,
    y: -50,
    scale: 0.95
  }} viewport={{
    once: true,
    margin: '-100px'
  }} transition={{
    duration: 0.8,
    delay: index * 0.1,
    ease: [0.16, 1, 0.3, 1]
  }} style={{
    perspective: 1000,
    transformOrigin: 'top center'
  }} className="group relative overflow-hidden rounded-sm w-full cursor-pointer" data-id="element-189">
      <img src={project.image} alt={project.title} className="w-full h-auto block transition-transform duration-1000 group-hover:scale-105" data-id="element-190" />
    </motion.div>;
}